import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface AppVulnerabilityFiltersProps {
  timeRange: string;
  onTimeRangeChange: (value: string) => void;
  appName: string;
  onAppNameChange: (value: string) => void;
  severity: string;
  onSeverityChange: (value: string) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function AppVulnerabilityFilters({
  timeRange,
  onTimeRangeChange,
  appName,
  onAppNameChange,
  severity,
  onSeverityChange,
  searchQuery,
  onSearchChange,
}: AppVulnerabilityFiltersProps) {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <Select value={timeRange} onValueChange={onTimeRangeChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Time range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All time</SelectItem>
          <SelectItem value="24h">Last 24 hours</SelectItem>
          <SelectItem value="7d">Last 7 days</SelectItem>
          <SelectItem value="30d">Last 30 days</SelectItem>
          <SelectItem value="90d">Last 90 days</SelectItem>
        </SelectContent>
      </Select>

      <Select value={appName} onValueChange={onAppNameChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Application" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All applications</SelectItem>
          <SelectItem value="Chrome">Google Chrome</SelectItem>
          <SelectItem value="Firefox">Mozilla Firefox</SelectItem>
          <SelectItem value="VSCode">Visual Studio Code</SelectItem>
          <SelectItem value="Slack">Slack</SelectItem>
          <SelectItem value="Zoom">Zoom</SelectItem>
        </SelectContent>
      </Select>

      <Select value={severity} onValueChange={onSeverityChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Severity" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All severities</SelectItem>
          <SelectItem value="CRITICAL">Critical</SelectItem>
          <SelectItem value="HIGH">High</SelectItem>
          <SelectItem value="MEDIUM">Medium</SelectItem>
          <SelectItem value="LOW">Low</SelectItem>
        </SelectContent>
      </Select>

      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search CVEs or apps..."
          className="pl-8"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
}
